import {emailRegexValidation} from 'presentation/constants';
import {translations} from 'presentation/translations-new';

const {addYourEmail, invalidEMail} =
	translations['pt-br'].privateFlow.bookingFlow.confirmationDrawer;

function emailHandler(value: string) {
	return {
		hasValue: Boolean(value),
		invalidValue: !emailRegexValidation.test(value || ''),
		toString() {
			if (!this.hasValue) return addYourEmail;
			if (this.invalidValue) return invalidEMail;
			return value;
		},
	};
}

export {emailHandler};
